export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (encodeURIComponent, expand_used_by, general, inventory, loaded, plural, renderPickupDelivery, usage) {
      pug_mixins["options"] = pug_interp = function(available, selected){
var block = (this && this.block), attributes = (this && this.attributes) || {};
// iterate (available)
;(function(){
  var $$obj = (available);
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var v = $$obj[pug_index0];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", v, true, true)+pug_attr("selected", (v == selected), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = v) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var v = $$obj[pug_index0];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", v, true, true)+pug_attr("selected", (v == selected), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = v) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
    }
  }
}).call(this);

};


























pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E";
if (loaded) {
pug_html = pug_html + "\u003Ch1\u003EInventory\u003C\u002Fh1\u003E\u003Ctable class=\"table\"\u003E\u003Cthead\u003E\u003Ctr\u003E\u003Cth\u003EStatus\u003C\u002Fth\u003E\u003Cth\u003EName\u003C\u002Fth\u003E\u003Cth\u003EFrom date\u003C\u002Fth\u003E\u003Cth\u003ETo date\u003C\u002Fth\u003E\u003Cth\u003EDelivery\u002FPickup\u003C\u002Fth\u003E\u003Cth\u003EStatus\u003C\u002Fth\u003E\u003Cth\u003EQuantity\u003C\u002Fth\u003E\u003Cth\u003EAdjust qty\u003C\u002Fth\u003E\u003Cth\u003ELow qty alarm\u003C\u002Fth\u003E\u003Cth\u003EOut of stock msg\u003C\u002Fth\u003E\u003Cth\u003E\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody\u003E";
// iterate inventory
;(function(){
  var $$obj = inventory;
  if ('number' == typeof $$obj.length) {
      for (var idx = 0, $$l = $$obj.length; idx < $$l; idx++) {
        var inv = $$obj[idx];
var isPrimary = inv.status == "Available";
pug_html = pug_html + "\u003Ctr" + (pug_attr("class", pug_classes(["inv",{available: isPrimary, inactive: ! inv.active}], [false,true]), false, true)+pug_attr("data-idx", idx, true, true)) + "\u003E\u003Ctd\u003E";
if (isPrimary) {
pug_html = pug_html + "\u003Cselect name=\"active\"\u003E\u003Coption" + (" value=\"0\""+pug_attr("selected", !inv.active, true, true)) + "\u003EInactive\u003C\u002Foption\u003E\u003Coption" + (" value=\"1\""+pug_attr("selected", inv.active, true, true)) + "\u003EActive\u003C\u002Foption\u003E\u003C\u002Fselect\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = inv.name) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = inv.fromDate) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = inv.toDate) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = renderPickupDelivery(inv)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = inv.status) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = inv.quantity) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"add-available-cont\"\u003E";
if (isPrimary) {
pug_html = pug_html + "\u003Cinput name=\"qty\" type=\"number\"\u003E\u003Cbutton class=\"add-available\"\u003EAdd\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd class=\"set-alarm-cont\"\u003E";
if (isPrimary) {
pug_html = pug_html + "\u003Cinput" + (" name=\"alarm\" type=\"number\""+pug_attr("value", inv.alarm, true, true)) + "\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E";
if (isPrimary) {
pug_html = pug_html + "\u003Cinput" + (" name=\"out_of_stock_msg\""+pug_attr("value", inv.out_of_stock_msg, true, true)) + "\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E";
if (isPrimary && ! inv.active) {
pug_html = pug_html + "\u003Cbutton class=\"delete-primary\"\u003E Delete\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var idx in $$obj) {
      $$l++;
      var inv = $$obj[idx];
var isPrimary = inv.status == "Available";
pug_html = pug_html + "\u003Ctr" + (pug_attr("class", pug_classes(["inv",{available: isPrimary, inactive: ! inv.active}], [false,true]), false, true)+pug_attr("data-idx", idx, true, true)) + "\u003E\u003Ctd\u003E";
if (isPrimary) {
pug_html = pug_html + "\u003Cselect name=\"active\"\u003E\u003Coption" + (" value=\"0\""+pug_attr("selected", !inv.active, true, true)) + "\u003EInactive\u003C\u002Foption\u003E\u003Coption" + (" value=\"1\""+pug_attr("selected", inv.active, true, true)) + "\u003EActive\u003C\u002Foption\u003E\u003C\u002Fselect\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = inv.name) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = inv.fromDate) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = inv.toDate) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = renderPickupDelivery(inv)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = inv.status) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = inv.quantity) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"add-available-cont\"\u003E";
if (isPrimary) {
pug_html = pug_html + "\u003Cinput name=\"qty\" type=\"number\"\u003E\u003Cbutton class=\"add-available\"\u003EAdd\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd class=\"set-alarm-cont\"\u003E";
if (isPrimary) {
pug_html = pug_html + "\u003Cinput" + (" name=\"alarm\" type=\"number\""+pug_attr("value", inv.alarm, true, true)) + "\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E";
if (isPrimary) {
pug_html = pug_html + "\u003Cinput" + (" name=\"out_of_stock_msg\""+pug_attr("value", inv.out_of_stock_msg, true, true)) + "\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E";
if (isPrimary && ! inv.active) {
pug_html = pug_html + "\u003Cbutton class=\"delete-primary\"\u003E Delete\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Ctr class=\"available add-new-form\"\u003E\u003Ctd\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cselect name=\"name\"\u003E";
pug_mixins["options"](general, null);
pug_html = pug_html + "\u003C\u002Fselect\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cinput class=\"datefield\" name=\"fromDate\"\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cinput class=\"datefield\" name=\"toDate\"\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cselect name=\"pickupDelivery\"\u003E\u003Coption\u003EBoth\u003C\u002Foption\u003E\u003Coption\u003EPickup\u003C\u002Foption\u003E\u003Coption\u003EDelivery\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cbutton class=\"add-new-dates\"\u003EAdd new dates\u003C\u002Fbutton\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003Ch2\u003EProduct usage\u003C\u002Fh2\u003E\u003Cul class=\"product_usage\"\u003E";
// iterate general
;(function(){
  var $$obj = general;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var inv = $$obj[pug_index4];
pug_html = pug_html + ("\u003Cli class=\"general-inventory\"\u003E" + (pug_escape(null == (pug_interp = inv) ? "" : pug_interp)));
var used_by = usage[inv]
if (used_by && used_by.length > 0) {
if (expand_used_by[inv]) {
pug_html = pug_html + "\n\u003Ca" + (" class=\"used_by_expand clickable\""+pug_attr("data-inv", inv, true, true)+" data-expand=\"0\"") + "\u003E(collapse products)\u003C\u002Fa\u003E\u003Cul\u003E";
// iterate used_by
;(function(){
  var $$obj = used_by;
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var u = $$obj[pug_index5];
pug_html = pug_html + "\u003Cli\u003E" + (pug_escape(null == (pug_interp = u.qty) ? "" : pug_interp)) + ":\n\u003Ca" + (pug_attr("href", `#/shop/product/${encodeURIComponent(u.product_name)}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = u.product_name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\n" + (pug_escape(null == (pug_interp = u.choice) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var u = $$obj[pug_index5];
pug_html = pug_html + "\u003Cli\u003E" + (pug_escape(null == (pug_interp = u.qty) ? "" : pug_interp)) + ":\n\u003Ca" + (pug_attr("href", `#/shop/product/${encodeURIComponent(u.product_name)}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = u.product_name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\n" + (pug_escape(null == (pug_interp = u.choice) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
}
else {
pug_html = pug_html + "\n\u003Ca" + (" class=\"used_by_expand clickable\""+pug_attr("data-inv", inv, true, true)+" data-expand=\"1\"") + "\u003EUsed by " + (pug_escape(null == (pug_interp = used_by.length) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = plural(used_by.length, "product", "products")) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
}
else {
pug_html = pug_html + "\n\u003Ca" + (" class=\"clickable delete\""+pug_attr("data-inv", inv, true, true)) + "\u003E(delete)\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var inv = $$obj[pug_index4];
pug_html = pug_html + ("\u003Cli class=\"general-inventory\"\u003E" + (pug_escape(null == (pug_interp = inv) ? "" : pug_interp)));
var used_by = usage[inv]
if (used_by && used_by.length > 0) {
if (expand_used_by[inv]) {
pug_html = pug_html + "\n\u003Ca" + (" class=\"used_by_expand clickable\""+pug_attr("data-inv", inv, true, true)+" data-expand=\"0\"") + "\u003E(collapse products)\u003C\u002Fa\u003E\u003Cul\u003E";
// iterate used_by
;(function(){
  var $$obj = used_by;
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var u = $$obj[pug_index6];
pug_html = pug_html + "\u003Cli\u003E" + (pug_escape(null == (pug_interp = u.qty) ? "" : pug_interp)) + ":\n\u003Ca" + (pug_attr("href", `#/shop/product/${encodeURIComponent(u.product_name)}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = u.product_name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\n" + (pug_escape(null == (pug_interp = u.choice) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var u = $$obj[pug_index6];
pug_html = pug_html + "\u003Cli\u003E" + (pug_escape(null == (pug_interp = u.qty) ? "" : pug_interp)) + ":\n\u003Ca" + (pug_attr("href", `#/shop/product/${encodeURIComponent(u.product_name)}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = u.product_name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\n" + (pug_escape(null == (pug_interp = u.choice) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
}
else {
pug_html = pug_html + "\n\u003Ca" + (" class=\"used_by_expand clickable\""+pug_attr("data-inv", inv, true, true)+" data-expand=\"1\"") + "\u003EUsed by " + (pug_escape(null == (pug_interp = used_by.length) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = plural(used_by.length, "product", "products")) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
}
else {
pug_html = pug_html + "\n\u003Ca" + (" class=\"clickable delete\""+pug_attr("data-inv", inv, true, true)) + "\u003E(delete)\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cli\u003E\u003Cform\u003E\u003Cinput name=\"inventory_type\"\u003E\u003Cbutton class=\"add-new-inventory-type\"\u003EAdd new inventory type\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv\u003ELoading inventory...\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "encodeURIComponent" in locals_for_with ?
        locals_for_with.encodeURIComponent :
        typeof encodeURIComponent !== 'undefined' ? encodeURIComponent : undefined, "expand_used_by" in locals_for_with ?
        locals_for_with.expand_used_by :
        typeof expand_used_by !== 'undefined' ? expand_used_by : undefined, "general" in locals_for_with ?
        locals_for_with.general :
        typeof general !== 'undefined' ? general : undefined, "inventory" in locals_for_with ?
        locals_for_with.inventory :
        typeof inventory !== 'undefined' ? inventory : undefined, "loaded" in locals_for_with ?
        locals_for_with.loaded :
        typeof loaded !== 'undefined' ? loaded : undefined, "plural" in locals_for_with ?
        locals_for_with.plural :
        typeof plural !== 'undefined' ? plural : undefined, "renderPickupDelivery" in locals_for_with ?
        locals_for_with.renderPickupDelivery :
        typeof renderPickupDelivery !== 'undefined' ? renderPickupDelivery : undefined, "usage" in locals_for_with ?
        locals_for_with.usage :
        typeof usage !== 'undefined' ? usage : undefined));
    ;;return pug_html;}